import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views
import Dashboard from "views/admin/Dashboard.js";
import Maps from "views/admin/Maps.js";
import Settings from "views/admin/Settings.js";
import Tables from "views/admin/Tables.js";

//page user
import User from "views/admin/user/User";
import CreateUser from "views/admin/user/UserCreate";
import UpdateUser from "views/admin/user/UserUpdate";
import DeleteUser from "views/admin/user/UserDelete";
 
//page tentor
import Tentor from "views/admin/tentor/Tentor";
import CreateTentor from "views/admin/tentor/TentorCreate";
import ViewTentor from "views/admin/tentor/TentorView";
import UpdateTentor from "views/admin/tentor/TentorUpdate";
import DeleteTentor from "views/admin/tentor/TentorDelete";

//page siswa
import Siswa from "views/admin/siswa/Siswa";
import CreateSiswa from "views/admin/siswa/SiswaCreate";
import ViewSiswa from "views/admin/siswa/SiswaView";
import UpdateSiswa from "views/admin/siswa/SiswaUpdate";
import DeleteSiswa from "views/admin/siswa/SiswaDelete";

//page presensi
import Presensi from "views/admin/presensi/Presensi";
import CreatePresensi from "views/admin/presensi/PresensiCreate";
import ViewPresensi from "views/admin/presensi/PresensiView";
import UpdatePresensi from "views/admin/presensi/PresensiUpdate";
import DeletePresensi from "views/admin/presensi/PresensiDelete";

//page rekap
import Rekap from "views/admin/rekap/Rekap"
import ViewRekap from "views/admin/rekap/RekapView"
import Invoice from "components/Invoice"

//page pendapatan
import Pendapatan from "views/admin/pendapatan/Pendapatan"

export default function Admin() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/maps" exact component={Maps} />
            <Route path="/admin/settings" exact component={Settings} />
            <Route path="/admin/tables" exact component={Tables} />
            
            {/* user */}
            <Route path="/admin/user" exact component={User} />
            <Route path="/admin/user/create" exact component={CreateUser} />
            <Route path="/admin/user/update/:userId" exact component={UpdateUser} />
            <Route path="/admin/user/delete/:userId" exact component={DeleteUser} />
            {/* tentor */}
            <Route path="/admin/tentor" exact component={Tentor} />
            <Route path="/admin/tentor/create" exact component={CreateTentor} />
            <Route path="/admin/tentor/view/:userId" exact component={ViewTentor} />
            <Route path="/admin/tentor/update/:userId" exact component={UpdateTentor} />
            <Route path="/admin/tentor/delete/:userId" exact component={DeleteTentor} />
            {/* siswa */}
            <Route path="/admin/siswa" exact component={Siswa} />
            <Route path="/admin/siswa/create" exact component={CreateSiswa} />
            <Route path="/admin/siswa/view/:siswaId" exact component={ViewSiswa} />
            <Route path="/admin/siswa/update/:siswaId" exact component={UpdateSiswa} />
            <Route path="/admin/siswa/delete/:siswaId" exact component={DeleteSiswa} />
            {/* presensi */}
            <Route path="/admin/presensi" exact component={Presensi} />
            <Route path="/admin/presensi/create" exact component={CreatePresensi} />
            <Route path="/admin/presensi/view/:presensiId" exact component={ViewPresensi} />
            <Route path="/admin/presensi/update/:presensiId" exact component={UpdatePresensi} />
            {/* rekap */}
            <Route path="/admin/rekap" exact component={Rekap} />
            <Route path="/admin/rekap/view/:siswaId" exact component={ViewRekap} />
            {/* <Route path="/admin/rekap/view/print/:siswaId" hideAdminComponents={true} exact component={Invoice} /> */}
            {/* <Route path="/admin/presensi/delete/:presensiId" exact component={DeletePresensi} /> */}

            {/* pendapatan */}
            <Route path="/admin/pendapatan" exact component={Pendapatan} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
